import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon } from './icons/OrganicIcons';

const IniciaInfoPage = () => {
  const navigate = useNavigate();
  const [mounted, setMounted] = useState(false);
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    setMounted(true);
    (async () => {
      try {
        const res = await fetch('/.netlify/functions/getConfig');
        const json = await res.json();
        const data = json.data || json;
        setCfg(data);
      } catch (_) {
        setCfg(null);
      }
    })();
  }, []);


  const handleInscribirseClick = () => {
    navigate('/inicia/formulario');
  };

  const handleVolverClick = () => {
    navigate('/');
  };

  return (
    <div className={`min-h-screen portal-section transition-all duration-1000 ${mounted ? 'opacity-100' : 'opacity-0'}`}>
      {/* Fondo animado estilo Pixar */}
      <DigitalForestBackground />
      
      {/* Header */}
      <header className="relative z-20 bg-white/80 backdrop-blur-md border-b border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={handleVolverClick}
              className="flex items-center space-x-3 text-neutral-600 hover:text-green-400 transition-colors duration-200 group"
            >
              <div className="p-2 rounded-xl group-hover:bg-white/50 transition-all duration-200">
                <ArrowRightIcon className="w-5 h-5 rotate-180" />
              </div>
              <span className="font-medium" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>Volver</span>
            </button>
            <div className="relative">
              <img 
                src="/LOGO GUIA.png" 
                alt="GUIA AI Logo" 
                className="h-12 drop-shadow-soft"
              />
              <div className="absolute -inset-2 bg-gradient-to-br from-cyan-400 to-purple-400 opacity-10 rounded-full blur-lg"></div>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative z-10 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className={`space-y-8 animate-fade-in-up ${mounted ? 'opacity-100' : 'opacity-0'}`}>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-light text-neutral-700 leading-tight drop-shadow-lg" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
              <span className="bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">INICIA</span>
              <span className="text-neutral-700">: Transformación Estratégica Impulsada con IA</span>
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto text-neutral-600 leading-relaxed" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
              Un programa que no termina: tu inscripción te da acceso continuo a la comunidad INICIA y a futuras ediciones.
            </p>
            
            {/* Badges destacados */}
            <div className="flex flex-wrap justify-center gap-4 pt-4">
              <div className="flex items-center space-x-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium">
                <CheckIcon className="w-4 h-4" />
                <span>5 encuentros</span>
              </div>
              <div className="flex items-center space-x-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium">
                <CheckIcon className="w-4 h-4" />
                <span>90 minutos cada uno</span>
              </div>
              <div className="flex items-center space-x-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium">
                <CheckIcon className="w-4 h-4" />
                <span>Modalidad taller online</span>
              </div>
            </div>
            
            {/* CTAs dobles */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8">
              <button
                onClick={handleInscribirseClick}
                className="px-12 py-4 bg-gradient-to-r from-green-400 to-blue-400 text-white font-medium rounded-2xl shadow-soft hover:shadow-medium transition-all duration-300 transform hover:scale-105"
                style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
              >
                🎯 Inscribirme ahora
              </button>
              <a
                href="/static/Capacitacion%20IA%20-%20Programa%20INICIA.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="px-12 py-4 bg-white/80 backdrop-blur-sm border border-white/50 text-neutral-700 font-medium rounded-2xl shadow-soft hover:shadow-medium transition-all duration-300 transform hover:scale-105"
                style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
              >
                📖 Ver programa (PDF)
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Qué es INICIA Section */}
      <section className="relative z-10 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className={`space-y-8 animate-fade-in-up ${mounted ? 'opacity-100' : 'opacity-0'}`} style={{ animationDelay: '0.2s' }}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl mb-6 font-light text-neutral-700 leading-tight" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
              Qué es <span className="bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">INICIA</span>
            </h2>
            <div className="relative overflow-hidden rounded-[2rem] bg-white/80 backdrop-blur-xl border border-white/50 shadow-2xl p-8">
              <p className="text-lg text-neutral-600 leading-relaxed mb-6" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                Un programa intensivo para optimizar tu entorno digital e integrar la IA como copiloto.
              </p>
              <p className="text-lg text-neutral-600 leading-relaxed mb-8" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                Vas a aprender a comunicarte mejor, transformar datos en decisiones y consolidar hábitos digitales que sostienen el crecimiento.
              </p>
              <button
                onClick={handleInscribirseClick}
                className="px-8 py-3 bg-gradient-to-r from-green-400 to-blue-400 text-white font-medium rounded-2xl shadow-soft hover:shadow-medium transition-all duration-300 transform hover:scale-105"
                style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
              >
                👉 Inscribirme ahora
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Módulos del Programa */}
      <section className="relative z-10 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className={`text-center mb-16 animate-fade-in-up ${mounted ? 'opacity-100' : 'opacity-0'}`} style={{ animationDelay: '0.4s' }}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl mb-6 font-light text-neutral-700 leading-tight" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
              Módulos del Programa
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                number: "1",
                title: "Diagnóstico del Punto de Partida",
                description: "Evaluamos tu situación digital actual."
              },
              {
                number: "2", 
                title: "Organización Mínima Viable",
                description: "Estructuramos sistemas básicos efectivos."
              },
              {
                number: "3",
                title: "Comunicación Ágil y Coherente", 
                description: "Implementamos canales de comunicación claros."
              },
              {
                number: "4",
                title: "Datos → Métricas → Decisiones",
                description: "Convertimos información en acciones estratégicas."
              },
              {
                number: "5",
                title: "Hábitos Digitales y Plan de Acción",
                description: "Consolidamos rutinas para el éxito sostenible."
              }
            ].map((module, index) => (
              <div key={index} className="relative overflow-hidden rounded-[2rem] bg-white/80 backdrop-blur-xl border border-white/50 shadow-2xl p-8 text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-green-400 to-blue-400 rounded-2xl flex items-center justify-center shadow-soft mx-auto mb-6">
                  <span className="text-2xl font-bold text-white">{module.number}</span>
                </div>
                <h3 className="text-xl font-light text-neutral-700 mb-4 leading-tight" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                  {module.title}
                </h3>
                <p className="text-neutral-600 leading-relaxed" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                  {module.description}
                </p>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <button
              onClick={handleInscribirseClick}
              className="px-12 py-4 bg-gradient-to-r from-green-400 to-blue-400 text-white font-medium rounded-2xl shadow-soft hover:shadow-medium transition-all duration-300 transform hover:scale-105"
              style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
            >
              👉 Reservar mi lugar
            </button>
          </div>
        </div>
      </section>

      {/* Resultados que te llevás */}
      <section className="relative z-10 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className={`text-center mb-16 animate-fade-in-up ${mounted ? 'opacity-100' : 'opacity-0'}`} style={{ animationDelay: '0.6s' }}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl mb-6 font-light text-neutral-700 leading-tight" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
              Resultados que te llevás
            </h2>
          </div>
          
          <div className="relative overflow-hidden rounded-[2rem] bg-white/80 backdrop-blur-xl border border-white/50 shadow-2xl p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                "Diagnóstico digital inicial",
                "Organización mínima lista para usar",
                "Comunicación más ágil y coherente",
                "Datos transformados en métricas y decisiones",
                "Hábitos digitales sostenibles",
                "Acceso continuo a la comunidad INICIA y posibilidad de volver a cursar"
              ].map((result, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-gradient-to-br from-green-400 to-blue-400 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <CheckIcon className="w-4 h-4 text-white" />
                  </div>
                  <p className="text-neutral-700 leading-relaxed" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                    {result}
                  </p>
                </div>
              ))}
            </div>
            
            <div className="text-center mt-8">
              <button
                onClick={handleInscribirseClick}
                className="px-8 py-3 bg-gradient-to-r from-purple-400 to-pink-400 text-white font-medium rounded-2xl shadow-soft hover:shadow-medium transition-all duration-300 transform hover:scale-105"
                style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
              >
                👉 Quiero todo esto en mi organización
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Inversión */}
      <section className="relative z-10 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className={`space-y-8 animate-fade-in-up ${mounted ? 'opacity-100' : 'opacity-0'}`} style={{ animationDelay: '0.8s' }}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl mb-6 font-light text-neutral-700 leading-tight" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
              Inversión
            </h2>
            <div className="relative overflow-hidden rounded-[2rem] bg-white/80 backdrop-blur-xl border border-white/50 shadow-2xl p-8">
              <div className="space-y-6">
                <div>
                  <p className="text-sm text-neutral-500 mb-1" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>Próxima edición</p>
                  <p className="text-xl font-medium text-neutral-700 mb-4" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                    Próximamente
                  </p>
                </div>
                <div>
                  <p className="text-2xl font-medium text-neutral-700 mb-2" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                    AR${(cfg && typeof cfg.price === 'number' ? cfg.price : 360000).toLocaleString('es-AR')} por persona
                  </p>
                  <p className="text-lg text-neutral-600" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                    (programa completo de 5 encuentros)
                  </p>
                </div>
                <div className="bg-gradient-to-r from-green-50 to-blue-50 border border-green-200 rounded-xl p-4">
                  <p className="text-sm text-neutral-600" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                    Grupos de 3+ personas: valor especial por persona
                  </p>
                </div>
                <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border border-yellow-200 rounded-xl p-4">
                  <p className="text-sm text-neutral-600 flex items-start space-x-2" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                    <span className="text-lg">💡</span>
                    <span>Incluye acceso continuo a la comunidad INICIA y participación en futuras ediciones sin costo adicional.</span>
                  </p>
                </div>
                <button
                  onClick={handleInscribirseClick}
                  className="px-16 py-4 bg-gradient-to-r from-green-400 to-blue-400 text-white font-medium rounded-2xl shadow-soft hover:shadow-medium transition-all duration-300 transform hover:scale-105 text-lg"
                  style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
                >
                  Inscribirme ahora
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ediciones Especiales para Empresas */}
      <section className="relative z-10 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className={`space-y-8 animate-fade-in-up ${mounted ? 'opacity-100' : 'opacity-0'}`} style={{ animationDelay: '1.0s' }}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl mb-6 font-light text-neutral-700 leading-tight" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
              Ediciones Especiales para Empresas
            </h2>
            <div className="relative overflow-hidden rounded-[2rem] bg-white/80 backdrop-blur-xl border border-white/50 shadow-2xl p-8">
              <div className="space-y-6">
                <div className="text-left space-y-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-gradient-to-br from-green-400 to-blue-400 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <CheckIcon className="w-4 h-4 text-white" />
                    </div>
                    <div>
                      <h3 className="text-lg font-medium text-neutral-700 mb-2" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                        Alineación Estratégica
                      </h3>
                      <p className="text-neutral-600" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                        Aprendizajes individuales alineados con objetivos organizacionales.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-gradient-to-br from-green-400 to-blue-400 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <CheckIcon className="w-4 h-4 text-white" />
                    </div>
                    <div>
                      <h3 className="text-lg font-medium text-neutral-700 mb-2" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                        Flexibilidad Total
                      </h3>
                      <p className="text-neutral-600" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                        Adaptable en duración, modalidad y foco.
                      </p>
                    </div>
                  </div>
                </div>
                <button
                  onClick={() => window.open('mailto:info@guia-ai.com?subject=Solicitud de propuesta empresarial INICIA', '_blank')}
                  className="px-12 py-4 bg-gradient-to-r from-purple-400 to-pink-400 text-white font-medium rounded-2xl shadow-soft hover:shadow-medium transition-all duration-300 transform hover:scale-105"
                  style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
                >
                  👉 Solicitar propuesta empresarial
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contacto y Accesos */}
      <section className="relative z-10 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className={`space-y-8 animate-fade-in-up ${mounted ? 'opacity-100' : 'opacity-0'}`} style={{ animationDelay: '1.2s' }}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-neutral-700 leading-tight" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
              Contacto y Accesos
            </h2>
            <div className="relative overflow-hidden rounded-[2rem] bg-white/80 backdrop-blur-xl border border-white/50 shadow-2xl p-8">
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="text-center">
                    <h3 className="text-lg font-medium text-neutral-700 mb-2" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                      Instagram
                    </h3>
                    <a 
                      href="https://instagram.com/somosguia.ai" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-green-600 hover:text-green-700 transition-colors"
                      style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
                    >
                      @somosguia.ai
                    </a>
                  </div>
                  <div className="text-center">
                    <h3 className="text-lg font-medium text-neutral-700 mb-2" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                      Email
                    </h3>
                    <a 
                      href="mailto:info@guia-ai.com"
                      className="text-green-600 hover:text-green-700 transition-colors"
                      style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
                    >
                      info@guia-ai.com
                    </a>
                  </div>
                </div>
                <div className="text-center">
                  <h3 className="text-lg font-medium text-neutral-700 mb-4" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                    Descarga el programa completo
                  </h3>
                  <div className="flex flex-col items-center space-y-4">
                    <a
                      href="/static/Capacitacion%20IA%20-%20Programa%20INICIA.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center space-x-2 px-8 py-3 bg-gradient-to-r from-green-400 to-blue-400 text-white font-medium rounded-2xl shadow-soft hover:shadow-medium transition-all duration-300 transform hover:scale-105"
                      style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
                    >
                      <span>📱</span>
                      <span>Descarga directa al PDF del programa</span>
                    </a>
                    <div className="text-center">
                      <p className="text-sm text-neutral-600 mb-2" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
                        O escanea el QR:
                      </p>
                      <img 
                        src="/static/qr_inicia.png" 
                        alt="QR Code para descargar el programa INICIA"
                        className="w-24 h-24 mx-auto rounded-lg shadow-soft"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative z-20 bg-neutral-900/90 backdrop-blur-md border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <img 
              src="/LOGO GUIA.png" 
              alt="GUIA AI Logo" 
              className="h-16 mx-auto opacity-80"
            />
            <div className="absolute -inset-4 bg-gradient-to-br from-cyan-400 to-purple-400 opacity-10 rounded-full blur-xl"></div>
            <p className="text-neutral-400 font-medium mt-4" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
              'Inteligencia que marca el rumbo'
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

// Componente de fondo digital forest con estilo Pixar (igual que en LandingPage)
const DigitalForestBackground = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {/* Gradiente de fondo más cálido y acogedor */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(180deg, #e8f5e8 0%, #b8e6ff 40%, #a3e6c1 80%, #e0fff7 100%)'
        }}
      />
      
      {/* Líneas verticales del bosque - más suaves y orgánicas */}
      {[...Array(15)].map((_, i) => (
        <div
          key={i}
          className="absolute top-0 w-1 bg-gradient-to-b from-transparent via-white/20 to-transparent"
          style={{
            left: `${Math.random() * 100}%`,
            height: '120vh',
            animation: `forest-down ${8 + Math.random() * 4}s linear infinite`,
            animationDelay: `${Math.random() * 8}s`,
            opacity: 0.3 + Math.random() * 0.4,
            filter: 'blur(0.5px)'
          }}
        />
      ))}
      
      {/* Partículas mágicas flotantes - más suaves y naturales */}
      {[...Array(20)].map((_, i) => (
        <div
          key={`particle-${i}`}
          className="absolute rounded-full bg-white/30 backdrop-blur-sm"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            width: `${4 + Math.random() * 8}px`,
            height: `${4 + Math.random() * 8}px`,
            animation: `particle-up ${10 + Math.random() * 10}s ease-in-out infinite`,
            animationDelay: `${Math.random() * 10}s`,
            boxShadow: '0 0 10px rgba(255, 255, 255, 0.5)'
          }}
        />
      ))}
      
      {/* Halos de luz suaves */}
      {[...Array(8)].map((_, i) => (
        <div
          key={`halo-${i}`}
          className="absolute rounded-full bg-gradient-radial from-white/20 to-transparent"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            width: `${100 + Math.random() * 200}px`,
            height: `${100 + Math.random() * 200}px`,
            animation: `breathe ${6 + Math.random() * 4}s ease-in-out infinite`,
            animationDelay: `${Math.random() * 6}s`
          }}
        />
      ))}
    </div>
  );
};

export default IniciaInfoPage;
